import { create } from "zustand";
import CreditService from "../services/CreditService";
import { StorageService } from "../services/StorageService";

const useCreditProfileStore = create((set, get) => ({
  data: {},
  fetchedState: "LOADING",
  isCreditBetaUser: null,
  hasViewedCreditSystemTnc: false,
  updateTnc: () => {
    set({ hasViewedCreditSystemTnc: true });
  },

  fetchData: async ({ hardCheck = true } = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (get().data?.isCreditBetaUser === false || hardCheck === false) {
          const isObjectExpired = StorageService.checkObjectForTimeOut({
            obj: get()
          });
          if (!isObjectExpired) {
            set({});
            resolve(true);
            return;
          }
        }
        const response = await CreditService.userCreditProfile();
        response.creditsDateOfExpiry = response.creditsDateOfExpiry
          ? new Date(response.creditsDateOfExpiry)
          : null;
        let showExpiringCredits = false;
        let differenceInDays = 0;
        if (response.creditsDateOfExpiry) {
          const today = new Date();
          const differenceInMillis =
            response.creditsDateOfExpiry?.getTime() - today.getTime();
          differenceInDays = differenceInMillis / (1000 * 3600 * 24);
          showExpiringCredits = differenceInDays >= 0 && differenceInDays <= 7;
        }
        let obj = {
          data: { ...response, showExpiringCredits, differenceInDays: differenceInDays.toFixed(0) },
          fetchedState: "SUCCESS",
          isCreditBetaUser: response.isCreditBetaUser,
          hasViewedCreditSystemTnc: response.hasViewedCreditSystemTnc
        };
        obj = StorageService.modifyObjectForStorage({
          obj,
          timeOutInMinutes: 10
        });
        set(obj);
        resolve(true);
      } catch (err) {
        set({
          fetchedState: "ERROR",
          data: {}
        });
        reject(err);
      }
    });
  }
}));

export default useCreditProfileStore;
